/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import "./NotFoundPage.less";
import { Result, Button, Space, Divider } from "antd";
import { useHistory } from "react-router-dom";
import { NotFound } from "icons";

const NotFoundPage: React.FC = () => {
  const history = useHistory();

  const navigate = () => {
    history.goBack();
  };

  return (
    <>
      <Space
        direction="horizontal"
        align="center"
        style={{
          width: "100%",
          height: "100%",
          justifyContent: "center",
        }}
      >
        <Result
          className="result-ant-custom"
          title="Oops!"
          subTitle="A página que você tentou acessar não está disponível."
          extra={
            <Space direction="vertical">
              <NotFound />
              <Divider />
              <Button onClick={navigate} type="dashed">
                Voltar
              </Button>
            </Space>
          }
        />
      </Space>
    </>
  );
};

export default NotFoundPage;
